import React, { useEffect, useState } from "react";
import tea from "../assets/TESTER .gif";
import HappyFamily from "../assets/happy-family.webp";
import ticks from "../assets/articale/ticks.png";

const TrySlimetics = () => {
  const [vid, setVid] = useState(null);

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);
  // a 

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        How Can You Try Slimetics?
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={tea}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p>
          <span>{" Click the big blue button labeled"}</span>{" "}
          {/* {vid ? (
            <a id="cta-button" href={`#=${vid}`} rel="noopener noreferrer">
              <span
                className="font-bold text-blue-600 hover:underline bg-[#ffbf00]"
                title="GET Herbal Tea Therapy slimetics NOW"
              >
                {"“GET 40% OFF Slimetics Now!”"}
              </span>
            </a>
          ) : ( */}
            <a id="cta-button" href="https://track.watchthisnow.io/click" rel="noopener noreferrer">
              <span
                className="font-bold text-blue-600 hover:underline bg-[#ffbf00]"
                title="GET Herbal Tea Therapy slimetics NOW"
              >
                {"“GET 40% OFF slimetics Now!”"}
              </span>
            </a>
          {/* )}{" "} */}
          You’ll be taken to a secure page where your discount is already
          applied
        </p>

        <p>
          Just enter your details and choose the package that works best for
          you.
        </p>

        <p>
          <span className="  font-bold">
            {" "}
            Why Most People Choose 3 or 6 Bottles:
          </span>
        </p>
        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt="ticks"
            height={20}
            width={20}
            className="object-contain"
          />
          Consistency supports long-term results
        </p>
        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt="ticks"
            height={20}
            width={20}
            className="object-contain"
          />
          Better value with bulk pricing
        </p>
        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt="ticks"
            height={20}
            width={20}
            className="object-contain"
          />
          Lower shipping costs—and less risk of running out
        </p>
        <p>
          If you’re working to feel lighter, more energized, and more in control
          of your digestion and weight—this is your opportunity to begin.
        </p>
        <p>
          <span className="  font-bold"> GET 40% OFF SLIMETICS</span>
        </p>
        <div className="relative w-full mb-6">
          <img
            src={HappyFamily}
            alt="happy woman"
            className="w-full rounded-3xl border border-gray-100"
            draggable="false"
          />
        </div>
        <p>Remember: this isn’t just about numbers on a scale.</p>
        <p>
          It’s about your energy, your confidence—and being able to enjoy life
          with the people you love.
        </p>

        <p>
          <span className="  font-bold"> You Deserve to Feel Better</span>
        </p>



        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt=""
            height={20}
            width={20}
            className="object-contain"
          />
          Wake up feeling refreshed and lighter
        </p>


        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt=""
            height={20}
            width={20}
            className="object-contain"
          />
          Support smoother digestion and fewer cravings
        </p>


        <p className="flex items-center gap-2.5">
          <img
            src={ticks}
            alt=""
            height={20}
            width={20}
            className="object-contain"
          />
         Take control of your gut and metabolism naturally
        </p>
       

        <p>
          Thousands of people have already taken the step—and now it’s your
          turn.
        </p>

        <p>
          <span className="  font-bold">
            {" "}
            Daily Use. Gentle Results. Real Support.
          </span>
        </p>

        <p>
          Just take Slimetics once per day to nourish your gut, support natural
          metabolism, and feel better from within.
        </p>

        <p>
          Unlike synthetic pills or restrictive diets, Slimetics is powered by
          microbiome science—and supports your health without extremes.
        </p>

        <p>
          <span className="  font-bold">
            {" "}
            Imagine Waking Up Feeling Better Each Day
          </span>
        </p>

        <p>
          No crash diets. No harsh stimulants. Just your body, supported by
          nature and science.
        </p>

        <p>
          <span className="  font-bold"> Ready to See the Difference?</span>
        </p>

        <p>
          Try Slimetics today—risk-free. It’s backed by a{" "}
          <span class="font-bold"> 60-day money-back guarantee.</span>
        </p>

        <div className="flex justify-center my-5">
          <div className="flex justify-center my-5">
            {/* {vid ? ( */}
              <a id="cta-button" href="https://track.watchthisnow.io/click" rel="noopener noreferrer">
                {/* a  */}
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET 40% OFF slimetics"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            {/* ) : (
              <a id="cta-button" href={`#=${vid}`} rel="noopener noreferrer">
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET 40% OFF slimetics"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrySlimetics;
